import React from "react";
import "./flex.scss";

interface propTypes {
  children: React.ReactNode;
  column?: boolean;
  gap?: number;
  justifyCenter?: boolean;
  justifyBetween?: boolean;
  justifyAround?: boolean;
  alignCenter?: boolean;
  selfCenter?: boolean;
  fullHeight?: boolean;
  height?: string;
  selfStart?: boolean;
  minHeight?: string;
  selfStretch?: boolean;
  className?: string;
}

const Flex = ({
  justifyCenter,
  justifyBetween,
  justifyAround,
  alignCenter,
  selfCenter,
  fullHeight,
  selfStart,
  selfStretch,
  gap,
  children,
  column,
  height,
  minHeight,
  ...props
}: propTypes): JSX.Element => {
  const classNames = require("classnames");
  const gapp = gap ? `gap-${gap}` : "";

  const flexClassNames = classNames("flex", `${gapp}`, {
    col: column,
    "justify-center": justifyCenter,
    "justify-between": justifyBetween,
    "justify-around": justifyAround,
    "align-center": alignCenter,
    "self-center": selfCenter,
    "full-height": fullHeight,
    "self-start": selfStart,
    "self-stretch": selfStretch,
  });

  return (
    <>
      <div
        className={`${flexClassNames}`}
        style={{ height: `${height}`, minHeight: `${minHeight}` }}
        {...props}
      >
        {children}
      </div>
    </>
  );
};

export default Flex;
